import { render, staticRenderFns } from "./invoicemsg.vue?vue&type=template&id=1017e708&scoped=true"
import script from "./invoicemsg.vue?vue&type=script&lang=ts"
export * from "./invoicemsg.vue?vue&type=script&lang=ts"
import style0 from "./invoicemsg.vue?vue&type=style&index=0&id=1017e708&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1017e708",
  null
  
)

export default component.exports